export default __webpack_public_path__ + "static/media/allpages.5b391c77.jpg";